module.exports = __webpack_public_path__ + "assets/img/11_734_big.6c36db56.jpg";